import React from "react";
import Table from "react-bootstrap/Table";
import { isMobile } from "react-device-detect";

const Fees = () => {
  return (
    <>
      <div style={{ marginTop: "60px" }}></div>

      <div style={{ marginTop: "60px" }}></div>
      <h3>Fee Information is Available upon request</h3>
    </>
  );
};

export default Fees;
